import { render, staticRenderFns } from "./SisterShip.vue?vue&type=template&id=fa793b70&scoped=true&"
import script from "./SisterShip.vue?vue&type=script&lang=js&"
export * from "./SisterShip.vue?vue&type=script&lang=js&"
import style0 from "./SisterShip.vue?vue&type=style&index=0&id=fa793b70&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "fa793b70",
  null
  
)

export default component.exports